import { render, staticRenderFns } from "./orgaManagerAdmin.vue?vue&type=template&id=64fb3aba&scoped=true"
import script from "./orgaManagerAdmin.vue?vue&type=script&lang=js"
export * from "./orgaManagerAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fb3aba",
  null
  
)

export default component.exports